import React from 'react';
import { useNavigate } from 'react-router-dom';
import './mobileHeader.css';

import logo from '../../assets/icons/primaryLogo.svg';
import bellIcon from '../../assets/icons/bell.svg';

const MobileHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="mobileHeader">
      <button className="mobileHeaderLogo" onClick={() => navigate('/Home')}>
        <img src={logo} alt="Cairo International Book Fair logo" />
      </button>

      <button
        className="mobileHeaderBell"
        onClick={() => navigate('/Notifications')}
      >
        <img src={bellIcon} alt="Notifications" />
      </button>
    </header>
  );
};

export default MobileHeader;